<template>
  <div class="footer">
    <div class="footer-part">
      <!-- <div class="footer-part__span">单页显示数量</div> -->
      <!-- <el-input-number
        class="footer-input__num"
        v-model="pageSize"
        controls-position="right"
        @change="handleChangeSize"
        :min="10"
        :max="100"
      ></el-input-number> -->
    </div>
    <div class="footer-part" v-if="totalNum > 20">
      <!-- <el-pagination
        :background="true"
        class="footer-pagination footer-part"
        @current-change="handleCurrentChange"
        @next-tick="handleNextTick"
        @prve-tick="handlePrveTick"
        :page-size.sync="pageSize"
        :pager-count="5"
        layout="prev,pager, next"
        :total="totalNum"
        next-text="下一页"
        prev-text="上一页"
      ></el-pagination> -->
      <div class="footer-part__span">每页显示</div>
      <el-pagination
        :background="true"
        class="footer-pagination footer-part"
        @size-change="handleChangeSize"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        :page-sizes="[20, 40, 100]"
        :page-size="pageSize"
        layout="sizes,total,prev, pager, next"
        :total="totalNum"
        next-text="下一页"
        prev-text="上一页"
      >
      </el-pagination>
    </div>
    <!-- <div class="footer-part" v-if="totalNum <= 10"></div> -->
  </div>
</template>

<script>
export default {
  name: 'TableFooterPagination',
  props: {
    totalNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      size: 1,
      pageSize: 20,
      currentPage2: 1
    };
  },
  methods: {
    /**
     * 控制分页数回调
     * @param {number} pageSize
     */
    handleChangeSize(pageSize) {
      this.$emit('onChangePageSize', pageSize);
    },
    /**
     * 改变当前页码触发回调
     * @param {number} page
     */
    handleCurrentChange(page) {
      this.$emit('onChangePage', page);
    },
    /**
     * 点击下一页触发回调
     */
    handleNextTick(page) {
      this.$emit('onChangePage', page);
    },
    /**
     * 点击上一页触发回调
     */
    handlePrveTick(page) {
      this.$emit('onChangePage', page);
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
  &-part {
    display: flex;
    &__span {
      margin-right: 10px;
      height: 30px;
      line-height: 30px;
      // color: $color-primary-light;
      font-size: 14px;
    }
    /deep/ .el-pager li {
      margin: 0px;
      background-color: #bfe1e1;
      color: rgba(51, 51, 51, 0.99);
      width: 50px;
      height: 30px;
      line-height: 30px;
      border-radius: 0px;
    }
    /deep/.el-pagination button {
      background-color: #bfe1e1;
      width: 50px;
      height: 30px;
      line-height: 30px;
      border-radius: 0;
    }
    /deep/.el-input__inner {
      height: 30px;
      line-height: 30px;
      width: 100px;
      border: 0px;
      background-color: #efefef;
      border-radius: 0;
    }
    .el-pagination__sizes {
    }
    /deep/.el-input-number {
      height: 30px;
      line-height: 30px;
      width: 86px;
      [class*='el-icon'] {
        transform: scale(1.2);
        font-size: 16px;
      }
      &__decrease,
      &__increase {
        line-height: 14px;
        border: 0px;
        background-color: #efefef;
      }
    }
    /deep/.el-icon-arrow-down:before {
      content: '\e790';
    }
    /deep/.el-icon-arrow-up:before {
      content: '\e78f';
    }
  }
}
</style>
